import {useEffect, useState} from 'react';

import {InteractionStatus} from '@azure/msal-browser/dist/utils/BrowserConstants';
import {useMsal} from '@azure/msal-react';
import {oneOfType, node, func} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../const';
import useAuth from '../hooks/providers/useAuth';
import useLoading from '../hooks/providers/useLoading';
import useProfile from '../hooks/providers/useProfile';
import useProjects from '../hooks/providers/useProjects';

const RequireConsentsAndHelpButtons = ({children}) => {
  const [consentsFetched, setConsentsFetched] = useState(false);

  const auth = useAuth();
  const {consents, fetchConsents, isConsentsLoading, getHelp, getHelpButtons, isGetHelpLoading, setIsGetHelpLoading} = useProfile();
  const {setCompletedApiCalls, setIsMaintenanceMode, setMaintenanceMessage} = useLoading();
  const {getConnectors} = useProjects();
  const {inProgress} = useMsal();

  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    (async () => {
      if ((consents || []).length < 1 && auth?.user?.tokenAad) {
        const res = await fetchConsents();

        if (!isConsentsLoading) {
          // The 503 maintenance is globally handled in useHttp
          if (!res.success && res.status >= 500 && res.status !== 503) {
            setIsMaintenanceMode(true);
            const defaultMessage = 'Nous vous remercions pour votre patience';
            setMaintenanceMessage(defaultMessage);
          }
          setCompletedApiCalls(prevCompleted => prevCompleted + 1);
        }
      } else if (consents.length > 0 && consents.filter(c => c?.consent_value).length < 2) {
        navigate(APP_ROUTES.subscribe);
        setConsentsFetched(true);
      } else {
        setConsentsFetched(true);
        getConnectors();
      }
    })();
  }, [inProgress, consents, auth?.user?.tokenAad]);

  useEffect(() => {
    (async () => {
      if (!getHelpButtons && !isGetHelpLoading && auth?.user?.tokenAad) {
        setIsGetHelpLoading(true);
        await getHelp();
        setIsGetHelpLoading(false);
        setCompletedApiCalls(prevCompleted => prevCompleted + 1);
      }
    })();
  }, []);

  if (!consentsFetched || (consents || []).length < 1 || isGetHelpLoading || !getHelpButtons) {
    return null;
  }

  return children;
};

RequireConsentsAndHelpButtons.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default RequireConsentsAndHelpButtons;
